var _excluded = ["text", "type", "utils", "isInverse", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import StyledHint from './hint.styles';
import InverseContext from '../../utilities/inverse-context';
import Type from '../type';
import { StyledCacheWrapper } from '../../styles';
var hintRequiredProps = {
  /**  'error' | 'success' | 'warning' (for text color) */
  type: PropTypes.oneOf(['success', 'error', 'warning', 'default']),
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** The hint text (message) */
  text: PropTypes.node,
  /** Add utility objects for styling */
  utils: PropTypes.object,
  /** Set to true if hint is on a dark background. */
  isInverse: PropTypes.oneOf(['auto', true, false])
};
var hintDefaultProps = {
  type: null,
  className: '',
  text: '',
  utils: {},
  isInverse: 'auto'
};
export var colorToTypeVariant = function colorToTypeVariant(type) {
  switch (type) {
    case 'success':
      return 'success';
    case 'error':
      return 'critical';
    case 'warning':
      return 'caution';
    default:
      return 'default';
  }
};
var role = function role(type) {
  if (type === 'error') return 'alert';
};
var typeFontWeight = function typeFontWeight(type) {
  switch (type) {
    case 'success':
      return 'bold';
    case 'error':
      return 'bold';
    case 'warning':
      return 'bold';
    default:
      return 'normal';
  }
};

/**
 * @ignore @description
 * ## Hint Component
 * Hints are used to provide a simple, descriptive message detailing an error/tip below an input area.
 *
 * @ignore @see Mesh: [Hint Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/informational-hint--default)
 *
 * @ignore @example
 * ```jsx
 * import { Hint } from 'mesh-component-library';
 *
 * <Hint {...props} />
 * ```
 */

var Hint = function Hint(props) {
  var text = props.text,
    type = props.type,
    utils = props.utils,
    isInverse = props.isInverse,
    className = props.className,
    other = _objectWithoutProperties(props, _excluded);
  if (text === '') {
    return null;
  }
  var useIsInverse = useContext(InverseContext);
  if (isInverse !== 'auto') useIsInverse = isInverse;
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledHint, _extends({
    className: className,
    utils: utils,
    isInverse: useIsInverse,
    type: type
  }, other), /*#__PURE__*/React.createElement(Type, {
    role: role(type),
    element: "div",
    variant: colorToTypeVariant(type),
    weight: typeFontWeight(type),
    isInverse: isInverse
  }, text)));
};
Hint.propTypes = hintRequiredProps;
Hint.defaultProps = hintDefaultProps;
export default Hint;